// Copyright (c) 2016 Deere & Company

import './pip-history-item-header.scss';
import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import PipDaysToExpiryWidget from '../../../pip/shared/components/pip-days-to-expiry-widget';
import PipHistory from '@deere/cps-it.warranty-model-factory/lib/pip-history';

const PipHistoryItemHeader = props =>
    <header className='pip-history-item-header'>
        <Link
            className='pip-history-item-description'
            to={`/pips/programs/${props.pip.pipId}?pin=${props.pin}`}
        >
            {props.pip.description}
        </Link>
        <div className='status-group'>
            <span className='pip-completion-status'>{props.pip.pipCompletionStatus.value}</span>
            <PipDaysToExpiryWidget
                daysLeft={props.pip.daysLeft}
                metric={props.pip.metric.key}
                pipCompletionStatus={props.pip.pipCompletionStatus.key}
                showIndicatorOnly={false}
            />
        </div>
    </header>;

PipHistoryItemHeader.displayName = 'PipHistoryItemHeader';
PipHistoryItemHeader.propTypes = {
    pin: PropTypes.string.isRequired,
    pip: PropTypes.instanceOf(PipHistory).isRequired
};

export default PipHistoryItemHeader;




// WEBPACK FOOTER //
// ./src/product/details/components/pip-history-item-header.js